import React from 'react';

import { Modal } from '@motorway/motorway-storybook-cra';

import type { ModalRequestCallbackProps } from './ModalRequestCallback.types';
import { ModalRequestCallbackContent } from './ModalRequestCallbackContent';

export const ModalRequestCallback: React.FC<ModalRequestCallbackProps> = ({ onDismiss, ...props }) => {
	return (
		<Modal dismissModal={onDismiss} size="small">
			<ModalRequestCallbackContent {...props} />
		</Modal>
	);
};
